/**
 * @generated SignedSource<<5fa435d4cf1d088e8d889a10f133de04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServicesTab_userProfile$data = {
  readonly analyticsId: number;
  readonly displayUsername: string;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "ServicesTab_userProfile";
};
export type ServicesTab_userProfile$key = {
  readonly " $data"?: ServicesTab_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServicesTab_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServicesTab_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "28f500f89d446d51ceec0514180bb86e";

export default node;
